import React from 'react';

class Pagination extends React.Component {

  constructor( props ){
    super( props );

    this.state = {
      totalitems: this.props.totalitems === undefined ? 0 : this.props.totalitems,
      maxitemsperpage: this.props.maxitemsperpage === undefined ? 0 : this.props.maxitemsperpage,
      maxpages: this.props.maxpages === undefined ? this.props.totalitems/this.props.maxitemsperpage : this.props.maxpages,
      maxpagesoffset: 0,
      maxpagesstart: 0,
      maxpagesend: this.props.maxpages === undefined ? Math.ceil( this.props.totalitems/this.props.maxitemsperpage ) : this.props.maxpages,
      pageindex: this.props.pageindex === undefined ? 0 : parseInt( this.props.pageindex, 10 ),
      pages: [],
      current_page: 1,
      hasError: false,
      error: {},
      info: {}
    };
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillMount( ){
    const pages = this.onBuildPages( this.state.totalitems, this.state.maxitemsperpage );
    this.setState({ pages: pages });
  }

  componentWillReceiveProps( newProps ){
    const pages = this.onBuildPages( newProps.totalitems, newProps.maxitemsperpage );

    this.setState( {
      totalitems: newProps.totalitems === undefined ? 0 : newProps.totalitems,
      maxitemsperpage: newProps.maxitemsperpage === undefined ? 0 : newProps.maxitemsperpage,
      pageindex: newProps.pageindex === undefined ? 0 : parseInt( newProps.pageindex, 0 ),
      pages: pages,
    } );
  }

  /* Build Functions */
  onBuildPages( totalitems, maxitemsperpage ){
    // Ceil the fraction to compensate for uneven partitions
    const pagecount = parseInt( Math.ceil( totalitems / maxitemsperpage ), 10 );

    let pages = [];
    let pageindex = 0;

    if( pagecount > 0 ) {

      while ( pageindex < pagecount ) {

        let startindex = ( pageindex * maxitemsperpage ); //caluclate the start index

        let endindex = ( startindex + ( maxitemsperpage - 1 ) ); //caluclate the end index


        if( endindex > ( totalitems - 1 ) ){
          endindex = totalitems - 1;
        }

        let page = {index: pageindex, label: pageindex+1, start: startindex + 1, end: endindex + 1};

        pages.push( page );

        pageindex++;
      }

      let page = pages[pages.length - 1];

      if( page.end !== parseInt( totalitems, 10 ) ){
        pages.push( {index: pageindex, label: pageindex+1, start: page.end,end: parseInt( totalitems, 10 ) - 1} );
      }
    }
    return pages;
  }

  /* Render Functions */
  onRenderPages( pages ){
    let maxpagesstart = this.state.maxpagesstart;
    let maxpagesend = this.state.maxpagesend;
    let renderedPages = [];
    let current_page = this.state.current_page;

    for( var index = maxpagesstart; index < ( maxpagesend - 1 ); index++ ){

      const page = pages[index];

      if( page !== undefined ){

        let buttonKey = 'pagination-button-' + page.label;

        if( current_page === parseInt( page.label, 10 ) ){
          renderedPages.push(
            <span className="pagination-button" style={{backgroundColor: '#CCCCCC', color: 'white'}} key={buttonKey} onClick={this.onPageChanged.bind( this, page )} >
              {page.label}
            </span>
          );
        } else {
          renderedPages.push(
            <span className="pagination-button" key={buttonKey} onClick={this.onPageChanged.bind( this, page )} >
              {page.label}
            </span>
          );
        }
      }

    }

    return renderedPages;
  }

  /* Events */
  onPageBack( pages, e ) {

    const prevpageindex = this.state.pageindex - 1;

    if( prevpageindex >= 0 ){
      const page = pages[prevpageindex];
      let maxpagesstart = page.index;
      if( maxpagesstart > ( pages.length - ( this.state.maxpages - 1 ) ) ) {
        maxpagesstart = ( pages.length - ( this.state.maxpages - 1 ) );
      }

      const current_page = this.state.current_page;

      this.setState( {
        pageindex: page.index,
        maxpagesstart: maxpagesstart,
        maxpagesend: maxpagesstart + this.state.maxpages,
        current_page: current_page - 1,
      } );

      if( this.props.onPageChanged !== undefined ){
        this.props.onPageChanged( page, e );
      }
    }
  }

  onPageChanged( page, e ){
    const pages = this.state.pages;

    if( page !== 0 ){

      let maxpagesstart = page.index;
      if( maxpagesstart > ( pages.length - ( this.state.maxpages - 1 ) ) ) {
        maxpagesstart = ( pages.length - ( this.state.maxpages - 1 ) );
      }

      this.setState( {
        pageindex: page.index,
        maxpagesstart: maxpagesstart,
        maxpagesend: maxpagesstart + this.state.maxpages,
        current_page: page.label,
      } );


      if( this.props.onPageChanged !== undefined ){
        this.props.onPageChanged( page, e );
      }
    }

  }

  /* Event render that occurs when the next button is pressed */
  onPageNext( pages, e ){

    // Get the next page index
    const nextpageindex = this.state.pageindex + 1;

    if( nextpageindex < ( pages.length ) ){
      const page = pages[nextpageindex];
      let maxpagesstart = page.index;
      if( maxpagesstart > ( pages.length - ( this.state.maxpages - 1 ) ) ) {
        maxpagesstart = ( pages.length - ( this.state.maxpages - 1 ) );
      }

      const current_page = this.state.current_page;
      this.setState( {
        pageindex: page.index,
        maxpagesstart: maxpagesstart,
        maxpagesend: maxpagesstart + this.state.maxpages,
        current_page: current_page + 1,
      } );

      if( this.props.onPageChanged !== undefined ){
        this.props.onPageChanged( page, e );
      }
    }
  }

  render(){

    if( this.state.hasError === false ) {
      const totalitems = parseInt( this.state.totalitems, 10 );
      const maxitemsperpage = parseInt( this.state.maxitemsperpage, 10 );
      const pagecount = parseInt( Math.ceil( totalitems / maxitemsperpage ), 10 );
      const pages = this.state.pages;
      const pageindex = this.state.pageindex;
      let backButton = '';
      let nextButton = '';

      if( pagecount > 1 ) {

        if( pageindex > 0 ){
          backButton = (
            <span className="pagination-button-back" key="pagination-button-back" onClick={this.onPageBack.bind( this, pages )}>
              {/*<i className="icon-dripicons-chevron-left"/>*/}
              <span className="button-caption">Back</span>
            </span>
          );
        }

        if( pageindex <= ( pages.length - 2 ) ){
          nextButton = (
            <span className="pagination-button-next" key="pagination-button-next" onClick={this.onPageNext.bind( this, pages )} >
              <span className="button-caption">Next</span>
              {/*<i className="icon-dripicons-chevron-right"/>*/}
            </span>
          );
        }

        return (
          <span className="pagination">
            {backButton}
            {this.onRenderPages( pages )}
            {nextButton}
          </span>
        );

      } else {
        return ( <span></span> );
      }
    } else {
      return ( <span></span> );
    }
  }
}

export default Pagination;



// WEBPACK FOOTER //
// ./src/presentation/Pagination.js